import React, { SVGProps } from 'react';

const EditableCellCrossIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width || '6'}
    height={height || '6'}
    fill={fill || 'none'}
    className={className}
    style={style}
    viewBox="0 0 6 6"
    xmlns="http://www.w3.org/2000/svg"
    data-palette="EditableCellCrossIcon">
    <path
      d="M2.9997 2.2344L4.9797 0.254398L5.5453 0.819998L3.5653 2.8L5.5453 4.78L4.9797 5.3456L2.9997 3.3656L1.0197 5.3456L0.454102 4.78L2.4341 2.8L0.454102 0.819998L1.0197 0.254398L2.9997 2.2344Z"
      fill="var(--negative)"
    />
  </svg>
);

export default EditableCellCrossIcon;
